export default {
  uiStates: {
    title: "UI State Catalogue",
    subtitle: "Visual reference for all stateful component states — dev only.",

    // Tab names (shown in app bar extension)
    tabs: {
      errors: "Error States",
      emptyStates: "Empty States",
      loading: "Loading Skeletons",
      dialogs: "Dialog States",
      misc: "Miscellaneous",
    },

    // State labels
    labels: {
      server: "Server Error",
      network: "Network Error",
      timeout: "Timeout Error",
      unknown: "Unknown Error",
      empty: "Empty (no visits)",
      filteredEmpty: "Filtered Empty",
      paymentRequired: "Payment Required",
      noResults: "No Results",
      noSamples: "No Samples",
      noSales: "No Sales",
      noProducts: "No Products",
      noPayments: "No Payments",
      noVisits: "No Visits (Patient Record)",
      noTests: "No Tests (Patient Record)",
      noFlaggedResults: "No Flagged Results",
      dialogHistoryEmpty: "History Dialog — Empty",
      dialogResultsEmpty: "Visit Results Dialog — Empty",
      snackbarSuccess: "Success Snackbar",
      snackbarError: "Error Snackbar",
      snackbarWarning: "Warning Snackbar",
      snackbarInfo: "Info Snackbar",
      fullPageSpinner: "Full-Page Spinner",
      comingSoon: "Coming Soon Placeholder",
      skeletons: {
        tableRows: "Table Rows",
        cardAndTable: "Card + Table Rows",
        patientHeader: "Patient Header + Results",
        serviceCards: "Service Cards",
      },
    },

    // Info tooltips — where each state is used
    usedIn: {
      server:
        "Used in: All Visits table, OTP Results/Balance pages, Corporate Results/Record pages, Patient Visits/Tests tables, Visit Results dialog, Flag Results dialog",
      network:
        "Used in: All Visits table, OTP Results/Balance pages, Corporate Results/Record pages, Patient Visits/Tests tables, Visit Results dialog, Flag Results dialog",
      timeout:
        "Used in: All Visits table, OTP Results/Balance pages, Corporate Results/Record pages, Patient Visits/Tests tables, Visit Results dialog, Flag Results dialog",
      unknown:
        "Used in: All Visits table, OTP Results/Balance pages, Corporate Results/Record pages, Patient Visits/Tests tables, Visit Results dialog, Flag Results dialog",
      empty: "Used in: All Visits table — no visits exist at all",
      filteredEmpty: "Used in: All Visits table — filters applied, zero matches",
      paymentRequired: "Used in: OTP Results page — payment overdue, results locked",
      noResults:
        "Used in: OTP Results page (DepartmentResultsSection, custom labels); Corporate Results page (page-level v-else, no visit data)",
      noSamples:
        "Used in: OTP Results page (SamplesSection, custom labels); Corporate Results page (SamplesSection, default labels)",
      noSales: "Used in: OTP Balance page — inline empty when visit has zero sales",
      noProducts: "Used in: OTP Balance page — ProductsTable #no-data slot (sale has no products)",
      noPayments: "Used in: OTP Balance page — PaymentsTable #no-data slot (sale has no payments)",
      noVisits: "Used in: Patient Record page — PatientVisitsTable #no-data slot",
      noTests: "Used in: Patient Record page — PatientTestsTable #no-data slot",
      noFlaggedResults: "Used in: Flag Results dialog — no flagged tests found for this visit",
      dialogHistoryEmpty:
        "Used in: Patient History dialog — no prior results recorded for this test",
      dialogResultsEmpty: "Used in: Visit Results dialog — visit has no results to display",
      snackbarSuccess: "Used in: Cache clear, PDF download confirmations",
      snackbarError: "Used in: All mutation failures via useErrorBoundary",
      snackbarWarning: "Used in: Background refresh failures",
      snackbarInfo: "Used in: Feature not implemented notifications",
      fullPageSpinner: "Used in: OTP entry page (auth check), login page",
      comingSoon: "Used in: Search, New Results, Starred pages",
      tableRows: "Used in: All Visits page",
      cardAndTable: "Used in: OTP Balance page",
      patientHeader: "Used in: OTP Results page",
      serviceCards: "Used in: About page (Services tab)",
    },

    // Fixture text (used in table empty states and alerts)
    fixture: {
      serverTitle: "Something went wrong",
      serverSubtitle:
        "A server error occurred while loading data. Please try again or contact support.",
      networkTitle: "Connection lost",
      networkSubtitle:
        "Unable to reach the server. Please check your internet connection and try again.",
      timeoutTitle: "Request timed out",
      timeoutSubtitle: "The server took too long to respond. Please try again.",
      unknownTitle: "Unexpected error",
      unknownSubtitle: "An unexpected error occurred. Please try again later.",
      emptyTitle: "No visits found",
      emptySubtitle: "No visits have been registered in the system yet.",
      filteredEmptyTitle: "No matching visits",
      filteredEmptySubtitle: "No visits match your current filters.",
      paymentTitle: "Payment pending",
      paymentSubtitle:
        "Your laboratory results are ready, but access requires payment of the outstanding balance. Please visit the reception desk or the laboratory cashier.",
      noResultsTitle: "No results available",
      noResultsSubtitle: "No examination results have been registered for this visit.",
      noSamplesTitle: "No samples recorded",
      noSamplesSubtitle: "No sample collection has been registered for this visit.",
      noSalesTitle: "No sales on record",
      noSalesSubtitle: "No sales have been registered for this visit.",
      noProductsTitle: "No products on record",
      noProductsSubtitle: "No products have been registered for this sale.",
      noPaymentsTitle: "No payments recorded",
      noPaymentsSubtitle: "No payments have been registered for this sale.",
      noVisitsTitle: "No visits found for this patient.",
      noVisitsSubtitle: "This patient has no recorded visits.",
      noTestsTitle: "No tests found for this patient.",
      noTestsSubtitle: "This patient has no recorded tests.",
      noFlaggedResultsTitle: "No flagged results",
      noFlaggedResultsSubtitle: "None of the results in this visit are flagged.",
      historyEmptyTitle: "No historical results found",
      historyEmptySubtitle: "No prior results have been recorded for this test.",
      retry: "Retry",
      clearFilters: "Clear filters",
      editFilters: "Edit filters",
      authTitle: "Session expired",
      authSubtitle: "Your session has expired. Please log in again.",
      validationTitle: "Invalid input",
      validationSubtitle: "Please correct the highlighted fields and try again.",
      comingSoonTitle: "Coming Soon",
      comingSoonSubtitle: "This feature is currently under development.",
      snackbarSuccessText: "Operation completed successfully",
      snackbarErrorText: "An error occurred. Please try again.",
      snackbarWarningText: "Could not refresh data.",
      snackbarInfoText: "Feature not implemented yet.",
      login: "Log in",
      refresh: "Refresh",
    },
  },
};
